import classNames from 'classnames';

import TCCoinSvg from '../SvgComponents/TCCoin_svg';

import './TCPill.scss';
import { MINIMUM_TC_ICON_SIZE } from '../../config/icons';
import { formatReadableNumber } from '../../utils/numbers';

export const TC_PILL_TYPE = {
  CURRENT: 'current',
  EARN: 'earn',
};

const formatBalance = (number = 0) => new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format(number);

const TCPill = ({
  balance,
  type = TC_PILL_TYPE.CURRENT,
  width = MINIMUM_TC_ICON_SIZE,
  height = MINIMUM_TC_ICON_SIZE,
  containerClassName,
  highlight,
  customText,
  amountType,
}) => {
  const isEarn = type === TC_PILL_TYPE.EARN;

  const getBalanceText = () => {
    if (customText) return customText;
    if (amountType === 'PERCENTAGE') return `Up to ${formatReadableNumber(balance * 100)}%`;
    if (amountType === 'VALUE') return `Up to $${formatBalance(balance)}`;
    return `$${formatBalance(balance)}`;
  };

  return (
    <div className={classNames('TCPill', { earn: isEarn, highlight }, containerClassName)}>
      <TCCoinSvg width={width} height={height} />
      <p>{getBalanceText()}</p>
    </div>
  );
};

export default TCPill;
